import { render, staticRenderFns } from "./AvailableLocation.vue?vue&type=template&id=6804d4b4"
import script from "./AvailableLocation.vue?vue&type=script&lang=js"
export * from "./AvailableLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports